import React from 'react';
import { Link } from 'react-router-dom';

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { Box, Grid, Typography } from '@mui/material';

import CopyCard from '@common/modules/Chat/Title/Rules/TeacherModalContent/CopyCard';
import {
	communicationRules,
	communicationRulesBulletList,
	copyCardData,
} from '@common/modules/Chat/Title/Rules/TeacherModalContent/rulesData';

import * as ListStyles from '../../../Steps/styled';
import * as Styled from './styled';

function SecondStep() {
	return (
		<Box>
			<Typography variant="subtitle2">
				Під час спілкування в чатах дотримуйтесь комунікативних
				<Link
					to="https://public.3.basecamp.com/p/JiqthNgRCyyPUYRWXdxfU9S7"
					target="_blank"
					style={{ paddingInline: '6px', color: '#C41C1C', fontWeight: '600' }}
				>
					стандартів компанії
				</Link>
				(ст. 7–8) та таких правил:
			</Typography>
			<Grid container spacing={1}>
				{communicationRules.map(({ text, title }, index) => (
					<Grid item xs={4} key={index}>
						<CopyCard text={text} title={title} />
					</Grid>
				))}
			</Grid>
			<Styled.List>
				{communicationRulesBulletList.map(({ text }, index) => (
					<Box display="flex" gap={1} alignItems="center" key={index}>
						<ListStyles.Step isActive sx={{ transform: 'scale(0.6)' }}>
							<CheckOutlinedIcon />
						</ListStyles.Step>
						<Typography variant="body2" fontFamily="MuseoSansCyrl">
							{text}
						</Typography>
					</Box>
				))}
			</Styled.List>
			<Typography variant="subtitle1" fontFamily="MuseoSansCyrl" fontWeight={600}>
				Орієнтовні шаблони відповідей на запитання, що не стосуються навчального матеріалу:
			</Typography>
			<Grid container spacing={1}>
				{copyCardData.map(({ title, text }, index) => (
					<Grid item xs={index === 2 ? 12 : 6} key={index}>
						<CopyCard withCopy title={title} text={text} />
					</Grid>
				))}
			</Grid>
		</Box>
	);
}

export default SecondStep;
